import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { DeviceModel } from '../models';
import { map } from 'rxjs/operators';
import { DeviceModelSearchParam } from '../models/device-model-search-param.model';

@Injectable({ providedIn: 'root' })
export class DeviceModelService {

  private path = '/device_models';

  constructor(private http: AlloxApiService) { }

  public search(param?: DeviceModelSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new DeviceModel(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new DeviceModel(obj))
    );
  }

  public post(item: DeviceModel) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: DeviceModel) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: DeviceModel[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }

}
